export enum MembersTpaPageId {
  Profile = 'member_page',
  Settings = 'member_settings_page',
}
